// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../../breakpoints.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_nav__Xi3Ka {
    --h: 280px;
    position: fixed;
    top: calc(100vh / 2 - var(--h) / 2 + var(--header-height) / 2);
    width: 250px;
}

.styles_nav__Xi3Ka.styles_nav-right__faIKt {
    right: 32px;
}

.styles_menu__1HjIn {
    --item-size: 14px;
    --item-gap: 3px;

    padding: 0;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: var(--item-gap);
    width: calc(var(--item-size) * 2 + var(--item-gap));
}

/*@media screen-md-max {*/
/*    .menu {*/
/*        --item-size: 22px;*/
/*        --item-gap: 4px;*/
/*    }*/
/*}*/

.styles_menu-right__3178J {
    margin: auto 0 60px auto;
    right: 0;
}

.styles_menu-left__\\+H7BF {
    position: absolute;
    top: calc(var(--item-size) * -2 - 60px);
    left: 0;
    margin: auto 0 60px 0;
}

.styles_menu__1HjIn span {
    display: block;
    width: var(--item-size);
    height: var(--item-size);
    border: 1px solid var(--primary-color);
    transition: background-color 0.4s;
}

.styles_menu__1HjIn:hover span {
    background-color: var(--primary-color);
}

.styles_list__I\\+3h5 {
    margin-top: -30px;
    list-style: none;
    padding: 0;
    color: var(--primary-color);
}

.styles_listItem__umE6R {
    position: relative;
    grid-gap: 26px;
    justify-content: flex-end;
    margin: 2px 0;
    height: 16px;
    width: 100%;
    color: var(--primary-color);
    font-size: 16px;
    padding: 0 70px 0 0;
    text-align: right;
}

.styles_listItem-right__-icID {
    transform-origin: bottom right;
}

.styles_listItem__umE6R span {
    display: block;
    /*transform: translateY(calc(var(--offset) / 4));*/
    opacity: 0;
    transition: opacity 0.4s;
    transform-origin: inherit;
}

.styles_listItem__umE6R:after {
    content: '';
    display: block;
    width: 24px;
    height: 1px;
    background: var(--primary-color);
    position: absolute;
    right: 0;
    bottom: 0;
    transform-origin: bottom right;
    /*transform: rotate(var(--rotate, 0));*/
    transition: width 0.4s;
}

/*.listItem:nth-child(3):after,*/
/*.listItem:last-child:after {*/
/*    !*top: 0;*!*/
/*    !*bottom: initial;*!*/
/*    !*transform-origin: top right;*!*/
/*}*/

/*.listItem:nth-child(2) {*/
/*    !*margin-bottom: 28px;*!*/
/*}*/

/*.listItem:first-child {*/
/*    --rotate: 30deg;*/
/*    --scale: 1.8;*/
/*    --offset: -42px;*/
/*}*/

/*.listItem:nth-child(2) {*/
/*    --rotate: 20deg;*/
/*    --scale: 1.4;*/
/*    --offset: -20px;*/
/*}*/

/*.listItem:nth-child(3) {*/
/*    --rotate: -20deg;*/
/*    --scale: 1.4;*/
/*    --offset: 20px;*/
/*}*/

/*.listItem:last-child {*/
/*    --rotate: -30deg;*/
/*    --scale: 1.8;*/
/*    --offset: 42px;*/
/*}*/

.styles_listItem__umE6R.styles_active__hwpQy:after {
    width: 40px;
}

.styles_listItem__umE6R.styles_active__hwpQy span {
    opacity: 1;
}

.styles_listItem-left__byQHi {
    padding-left: 46px;
    padding-right: 0;
    transform-origin: left bottom;
    text-align: left;
}

.styles_listItem-left__byQHi:after {
    left: 0;
    right: initial;
    transform-origin: left;
}

.styles_leftItem-right__e1PE\\+ {
    transform-origin: right bottom;
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/OverviewNavigation/styles.module.css"],"names":[],"mappings":"AAEA;IACI,UAAU;IACV,eAAe;IACf,8DAA8D;IAC9D,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;;IAEf,UAAU;IACV,aAAa;IACb,qCAAqC;IACrC,yBAAyB;IACzB,mDAAmD;AACvD;;AAEA,yBAAyB;AACzB,cAAc;AACd,6BAA6B;AAC7B,2BAA2B;AAC3B,QAAQ;AACR,IAAI;;AAEJ;IACI,wBAAwB;IACxB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,OAAO;IACP,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,wBAAwB;IACxB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kDAAkD;IAClD,UAAU;IACV,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA,gCAAgC;AAChC,+BAA+B;AAC/B,kBAAkB;AAClB,2BAA2B;AAC3B,uCAAuC;AACvC,IAAI;;AAEJ,2BAA2B;AAC3B,+BAA+B;AAC/B,IAAI;;AAEJ,0BAA0B;AAC1B,uBAAuB;AACvB,oBAAoB;AACpB,uBAAuB;AACvB,IAAI;;AAEJ,2BAA2B;AAC3B,uBAAuB;AACvB,oBAAoB;AACpB,uBAAuB;AACvB,IAAI;;AAEJ,2BAA2B;AAC3B,wBAAwB;AACxB,oBAAoB;AACpB,sBAAsB;AACtB,IAAI;;AAEJ,yBAAyB;AACzB,wBAAwB;AACxB,oBAAoB;AACpB,sBAAsB;AACtB,IAAI;;AAEJ;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC","sourcesContent":["@value screen-lg-min, screen-md-max from '../../../breakpoints.css';\n\n.nav {\n    --h: 280px;\n    position: fixed;\n    top: calc(100vh / 2 - var(--h) / 2 + var(--header-height) / 2);\n    width: 250px;\n}\n\n.nav.nav-right {\n    right: 32px;\n}\n\n.menu {\n    --item-size: 14px;\n    --item-gap: 3px;\n\n    padding: 0;\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: var(--item-gap);\n    width: calc(var(--item-size) * 2 + var(--item-gap));\n}\n\n/*@media screen-md-max {*/\n/*    .menu {*/\n/*        --item-size: 22px;*/\n/*        --item-gap: 4px;*/\n/*    }*/\n/*}*/\n\n.menu-right {\n    margin: auto 0 60px auto;\n    right: 0;\n}\n\n.menu-left {\n    position: absolute;\n    top: calc(var(--item-size) * -2 - 60px);\n    left: 0;\n    margin: auto 0 60px 0;\n}\n\n.menu span {\n    display: block;\n    width: var(--item-size);\n    height: var(--item-size);\n    border: 1px solid var(--primary-color);\n    transition: background-color 0.4s;\n}\n\n.menu:hover span {\n    background-color: var(--primary-color);\n}\n\n.list {\n    margin-top: -30px;\n    list-style: none;\n    padding: 0;\n    color: var(--primary-color);\n}\n\n.listItem {\n    position: relative;\n    grid-gap: 26px;\n    justify-content: flex-end;\n    margin: 2px 0;\n    height: 16px;\n    width: 100%;\n    color: var(--primary-color);\n    font-size: 16px;\n    padding: 0 70px 0 0;\n    text-align: right;\n}\n\n.listItem-right {\n    transform-origin: bottom right;\n}\n\n.listItem span {\n    display: block;\n    /*transform: translateY(calc(var(--offset) / 4));*/\n    opacity: 0;\n    transition: opacity 0.4s;\n    transform-origin: inherit;\n}\n\n.listItem:after {\n    content: '';\n    display: block;\n    width: 24px;\n    height: 1px;\n    background: var(--primary-color);\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    transform-origin: bottom right;\n    /*transform: rotate(var(--rotate, 0));*/\n    transition: width 0.4s;\n}\n\n/*.listItem:nth-child(3):after,*/\n/*.listItem:last-child:after {*/\n/*    !*top: 0;*!*/\n/*    !*bottom: initial;*!*/\n/*    !*transform-origin: top right;*!*/\n/*}*/\n\n/*.listItem:nth-child(2) {*/\n/*    !*margin-bottom: 28px;*!*/\n/*}*/\n\n/*.listItem:first-child {*/\n/*    --rotate: 30deg;*/\n/*    --scale: 1.8;*/\n/*    --offset: -42px;*/\n/*}*/\n\n/*.listItem:nth-child(2) {*/\n/*    --rotate: 20deg;*/\n/*    --scale: 1.4;*/\n/*    --offset: -20px;*/\n/*}*/\n\n/*.listItem:nth-child(3) {*/\n/*    --rotate: -20deg;*/\n/*    --scale: 1.4;*/\n/*    --offset: 20px;*/\n/*}*/\n\n/*.listItem:last-child {*/\n/*    --rotate: -30deg;*/\n/*    --scale: 1.8;*/\n/*    --offset: 42px;*/\n/*}*/\n\n.listItem.active:after {\n    width: 40px;\n}\n\n.listItem.active span {\n    opacity: 1;\n}\n\n.listItem-left {\n    padding-left: 46px;\n    padding-right: 0;\n    transform-origin: left bottom;\n    text-align: left;\n}\n\n.listItem-left:after {\n    left: 0;\n    right: initial;\n    transform-origin: left;\n}\n\n.leftItem-right {\n    transform-origin: right bottom;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-lg-min": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-lg-min"]}`,
	"screen-md-max": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["screen-md-max"]}`,
	"nav": `styles_nav__Xi3Ka`,
	"nav-right": `styles_nav-right__faIKt`,
	"menu": `styles_menu__1HjIn`,
	"menu-right": `styles_menu-right__3178J`,
	"menu-left": `styles_menu-left__+H7BF`,
	"list": `styles_list__I+3h5`,
	"listItem": `styles_listItem__umE6R`,
	"listItem-right": `styles_listItem-right__-icID`,
	"active": `styles_active__hwpQy`,
	"listItem-left": `styles_listItem-left__byQHi`,
	"leftItem-right": `styles_leftItem-right__e1PE+`
};
export default ___CSS_LOADER_EXPORT___;
